import { SearchCase } from "./caseModel";
export class DashboardUIState {
    public SelectedCasesTabIndex: number = 0;
    public SearchCase: SearchCase = new SearchCase('DateofDeath', false);
    public OpenCasesPageNum: number = 1;
    public AvailableCasesPageNum: number = 1;
    public DismissedCasesPageNum: number = 1;
    public SubmittedCasesPageNum: number = 1;
    public ShowClearFilter: boolean = false;
}